const Wrapper = ({ children }: { children: any }) => {
  return <div className={`flex min-h-screen flex-col justify-between overflow-x-hidden font-code`}>{children}</div>
}
export default Wrapper
